<button
  type="button"
  [ngClass]="buttonClass"
  [attr.aria-label]="ariaLabel"
  [attr.title]="ariaLabel"
  (click)="goBack()"
>
  <svg
    aria-hidden="true"
    focusable="false"
    [ngClass]="iconClass"
    viewBox="0 0 24 24"
  >
    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" stroke="none"/>
  </svg>
</button>
